module.exports = __webpack_public_path__ + "img/2025-08-16e_2.bafe0dad.jpg";